import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const currentUrl = window.location.href;
const extractUrl = currentUrl.split("/")[2];
const xtrUrl = extractUrl.split(".")[0];

const tenantApiUrl = `https://${xtrUrl}.cranesoftapp.com/tenantApiToken`;
const orderApiUrl = `https://${xtrUrl}.cranesoftapp.com/api/v1/kitchen-display/1`;

export const fetchSettinginfo = createAsyncThunk("order/setting", async () => {
  const response = await fetch(tenantApiUrl, {
    headers: {
      "Access-control-Request-method": "GET",
      Accept: "*/*",
      "Accept-Encoding": "gzip, deflate, br",
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const data = await response.json();
  return data.tenantAPIToken;
});

export const fetchDetails = createAsyncThunk(
  "order/fetch",
  async (_, { getState }) => {
    const state = getState();
    const tenantToken = state.Kitchen.tenantInfo;

    const response = await fetch(orderApiUrl, {
      headers: {
        "Access-control-Request-method": "GET",
        Accept: "*/*",
        "Accept-Encoding": "gzip, deflate, br",
        "Content-Type": "application/json",
        Authorization: `Bearer ${tenantToken}`,
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data?.orderInfo;
  }
);

const KitchenSlice = createSlice({
  name: "Kitchen",
  initialState: {
    status: "idle",
    orders: [],
    tenantFetchStatus: "idle",
    tenantInfo: "",
  },
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setDetails: (state, action) => {
      state.orders = action.payload;
    },
    removeCompleted: (state, action) => {
      const id = action.payload;
      state.orders = state.orders.filter(
        (order) => order.orderInfo.OrderNo !== id
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.orders = action.payload;
      })
      .addCase(fetchDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        toast.error(action.error.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .addCase(fetchSettinginfo.pending, (state) => {
        state.tenantFetchStatus = "loading";
      })
      .addCase(fetchSettinginfo.fulfilled, (state, action) => {
        state.tenantFetchStatus = "succeeded";
        state.tenantInfo = action.payload;
      })
      .addCase(fetchSettinginfo.rejected, (state, action) => {
        state.tenantFetchStatus = "failed";
        state.error = action.error.message;
        toast.error(action.error.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  },
});

export const KitchenActions = KitchenSlice.actions;

export default KitchenSlice;
